import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import CommentItem from 'components/molecules/comment_item';
// import { BiddingState, CommentDataTypes } from 'store/modules/bidding_store/types';
import CommentInput from 'components/molecules/comment_input';
import { ProfileState } from 'store/modules/profile_store/types';
import { createCommentImminence } from 'store/modules/get_dados_imminence_store/actions';
import { ImminenceState, CommentDataTypes } from 'store/modules/get_dados_imminence_store/types';

interface ImminanceCommentsListProps {
  biddingId: number;
  comments: Array<CommentDataTypes>;
}

const ImminanceCommentsList = (props: ImminanceCommentsListProps) => {
  const { biddingId, comments } = props;

  const dispatch = useDispatch();

  const { comments_imminence_request } = useSelector<ApplicationState, ImminenceState>(
    (state) => state.session.get_imminence,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const createImminenceComment = (comment: string) => {
    const data = {
      bidding_comment: {
        bidding_id: biddingId,
        message: comment,
      },
    };

    dispatch(createCommentImminence(biddingId, profile.name, data, profile.id));
  };

  return (
    <div className="bidding-info tour-bidding-notes d-print-none">
      <div className="col-md-2 p-0 bidding-info-title mb-1">Anotações</div>
      <div className="col-md-12 p-0">
        {comments?.map((comment) => (
          <CommentItem
            key={comment.id}
            id={comment.id}
            contact_client_id={comment.contact_client.id}
            contact_client_nome={comment.contact_client.nome}
            created_at={comment.created_at}
            message={comment.message}
            biddingId={biddingId.toString()}
            commentSource="imminence"
          />
        ))}
        <div className="row">
          <div className="col-md-12 mt-1">
            <CommentInput
              isLoading={comments_imminence_request[biddingId]?.create_comment?.loading}
              createComment={createImminenceComment}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImminanceCommentsList;
